export default __webpack_public_path__ + "static/media/avatar-s-12.51e6436d.jpg";